import React from 'react';
import { siteContent } from '../content/siteContent';

const About = () => {
  const { about } = siteContent;

  return (
    <section id="about" className="about" aria-labelledby="about-heading">
      <div className="container">
        <div className="about-layout">
          <article className="about-story surface-card">
            <span className="about-eyebrow">{about.eyebrow}</span>
            <div className="about-copy">
              <h2 id="about-heading">{about.heading}</h2>
              {about.sentences.map((sentence) => (
                <p key={sentence}>{sentence}</p>
              ))}
            </div>
          </article>
          <aside className="about-trust" aria-label={about.trustLabel}>
            <span className="about-trust__label">{about.trustLabel}</span>
            <strong className="about-trust__message">{about.trustLine}</strong>
            <span className="about-trust__detail">{about.trustDetail}</span>
            {about.reviewsHref && (
              <a
                className="about-trust__reviews-link"
                href={about.reviewsHref}
                target="_blank"
                rel="noopener noreferrer"
              >
                {about.reviewsLabel}
              </a>
            )}
          </aside>
        </div>
      </div>
    </section>
  );
};

export default About;
